import type React from 'react';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export const PhotoMobile: React.FC<Props> = ({ id, url, mobileUrl }) => {
	return (
		<div className="relative w-full">
			<picture>
				<source srcSet={mobileUrl} media="(max-width: 767px)" />
				{/* The ratio we generate from uploaded images is 25/14; align-top removes unwanted padding under the image */}
				<img fetchPriority="high" id={id} src={url} alt="" className="aspect-[25/14] w-full object-cover align-top" />
			</picture>
			{/* Apply a gradient mask over the image so that an image with a white background has a sharp bottom edge. */}
			{/* eslint-disable-next-line @change-ds/ds-no-raw-color-classname -- multiply-blended photo treatment, same in both modes since the photo doesn't flip */}
			<div className="absolute top-0 h-full w-full bg-[linear-gradient(#FFFFFF_71.5%,#CACACA_100%)] mix-blend-multiply" />
		</div>
	);
};
